module.exports = __webpack_public_path__ + "img/ic_hm_bath.svg";